var styles = {"box":"Button_box_1br62_1","is-absolute":"Button_is-absolute_1br62_12"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
